import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/** Opens a document after its temporary download URL is available. */
export const openDownload = store.effects.create((feature: Feature) =>
  feature.actions.download.success.observe().pipe(
    rxjs.tap(action => window.open(action.data.response, '_blank')),
    rxjs.ignoreElements(),
  ),
)
